import { useEffect, useState } from "react";
import { parseISO, differenceInSeconds } from 'date-fns';

export function useCountdown(expiredAt?: string | Date | null): string {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!expiredAt) return;

    const endDate = typeof expiredAt === 'string' ? parseISO(expiredAt) : expiredAt;

    const interval = setInterval(() => {
      const now = new Date();
      const diffInSec = differenceInSeconds(endDate, now);

      if (diffInSec <= 0) {
        setTimeLeft('Expired');
        clearInterval(interval);
        return;
      }

      const days = Math.floor(diffInSec / (3600 * 24));
      const hours = Math.floor((diffInSec % (3600 * 24)) / 3600);
      const minutes = Math.floor((diffInSec % 3600) / 60);
      const seconds = diffInSec % 60;

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    }, 1000);

    return () => clearInterval(interval);
  }, [expiredAt]);

  return timeLeft;
}